import Instance from '../../../Axios';

const RemoverParceiro = (id) => async (dispatch) => {
  console.log(id);
  await Instance()
    .delete(`/backend/parceiros/${id}`)
    .then(({ data }) => {
      dispatch({ type: 'DELETE_PARCEIRO', payload: data });
    })
    .catch(({ err }) => console.log(err));
};

export default RemoverParceiro;
